import Alert from '@mui/material/Alert'
import { Snackbar } from '@mui/material'
import React from 'react'

const Notification = (props: any) => {
  const { notify, setNotify } = props

  const handleClose = () => {
    setNotify({
      ...notify,
      isOpen: false,
    })
  }

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      open={notify.isOpen}
      autoHideDuration={5000}
      onClose={handleClose}
    >
      <Alert severity={notify.type}>{notify.message}</Alert>
    </Snackbar>
  )
}

export default Notification
